import { Component, inject, Input } from '@angular/core';
import { InvoiceStatus, ISaleStatus } from '../../../core/services/invoicing.service';
import { TranslatePipe } from '@ngx-translate/core';
import { StoresService } from '../../../core/services/stores.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-sales-status',
  imports: [TranslatePipe],
  templateUrl: './sales-status.component.html',
  styleUrl: './sales-status.component.scss'
})
export class SalesStatusComponent {
  @Input() sale?: any;

  readonly ISaleStatus = ISaleStatus;
  readonly InvoiceStatus = InvoiceStatus;

  private storesService = inject(StoresService);

  public isInvoicingActive = toSignal(this.storesService.isInvoicingActive());

}
